import { render, staticRenderFns } from "./BatchesByInsurance.vue?vue&type=template&id=777b4c2a"
import script from "./BatchesByInsurance.vue?vue&type=script&lang=js"
export * from "./BatchesByInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports